import { LayoutDashboard, Sliders, Users, UtensilsCrossed, CreditCard, FileText, Bell, MapPin, UserPlus, ScrollText } from "lucide-react";

export const adminNavItems = (t) => [
  { to: "/admin", icon: LayoutDashboard, label: t("dashboard"), end: true, tid: "admin-nav-dashboard" },
  { to: "/admin/create-business", icon: UserPlus, label: "Create Business", tid: "admin-nav-create-business" },
  { to: "/admin/service-modules", icon: Sliders, label: t("serviceModules"), tid: "admin-nav-modules" },
  { to: "/admin/states", icon: MapPin, label: "States", tid: "admin-nav-states" },
  { to: "/admin/waitlist", icon: Bell, label: "Waitlist", tid: "admin-nav-waitlist" },
  { to: "/admin/users", icon: Users, label: t("users"), tid: "admin-nav-users" },
  { to: "/admin/restaurants", icon: UtensilsCrossed, label: t("restaurants"), tid: "admin-nav-restaurants" },
  { to: "/admin/subscriptions", icon: CreditCard, label: t("subscription"), tid: "admin-nav-subscriptions" },
  { to: "/admin/audit-logs", icon: ScrollText, label: "Audit Logs", tid: "admin-nav-audit" },
  { to: "/admin/strategy", icon: FileText, label: "Strategy Docs", tid: "admin-nav-strategy" },
];
